import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import { contactDisplayName } from '../helpers'

const useStyles = makeStyles({
  panel: {
    background: 'var(--color-neutral-050)',
    border: '1px solid var(--color-neutral-200)',
    borderRadius: 'var(--border-radius-sm)',
    padding: '12px 16px'
  }
})

function ExistingFamilyCard ({ contact, family }) {
  const classes = useStyles()
  const displayName = contactDisplayName(contact)
  return (
    <div className={classes.panel}>
      <div className='font-size-xs opacity-lowlighted'>
        {displayName ? `${displayName} family` : 'Contact family'}
      </div>
      <div className='font-size-md font-bold mt-1'>
        {family?.name || '(unnamed family)'}
      </div>
    </div>
  )
}

ExistingFamilyCard.propTypes = {
  contact: PropTypes.object,
  family: PropTypes.object
}

export default ExistingFamilyCard
